class Bfsg {
    constructor() {
        this.initFootnoteAccordion.bind(this)();
    }

    initFootnoteAccordion() {
        const checkboxes = document.querySelectorAll(".js-accordion__checkbox");
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    checkbox.checked = !checkbox.checked;
                    checkbox.setAttribute("aria-expanded", checkbox.checked);
                }
            });
        });
    }
}
window.Bfsg = new Bfsg();
